import { MatchupStatusEnum } from '@/entities/matchup/constants';

const statusConfig = {
	[MatchupStatusEnum.SCHEDULED_MATCHUP_STATUS]: {
		color: 'bg-white',
		border: 'border-gray-300/50',
		textColor: 'text-gray-700'
	},
	[MatchupStatusEnum.IN_PROGRESS_MATCHUP_STATUS]: {
		color: 'bg-error-500',
		border: 'border-error-200 animate-pulse',
		textColor: 'text-white'
	},
	[MatchupStatusEnum.COMPLETED_MATCHUP_STATUS]: {
		color: 'bg-white',
		border: 'border-gray-300/50',
		textColor: 'text-gray-700'
	},
	[MatchupStatusEnum.DELAYED_MATCHUP_STATUS]: {
		color: 'bg-white',
		border: 'border-gray-300/50',
		textColor: 'text-gray-700'
	},
	[MatchupStatusEnum.UNSCHEDULED_MATCHUP_STATUS]: {
		color: 'bg-white',
		border: 'border-gray-300/50',
		textColor: 'text-gray-700'
	},
	[MatchupStatusEnum.UNDEFINED_MATCHUP_STATUS]: {
		color: 'bg-white',
		border: 'border-gray-300/50',
		textColor: 'text-gray-700'
	},
	[MatchupStatusEnum.SCHEDULED_WAITING_FOR_HOME_TEAM_LINEUP]: {
		color: 'bg-white',
		border: 'border-gray-300/50',
		textColor: 'text-gray-700'
	},
	[MatchupStatusEnum.SCHEDULED_WAITING_FOR_AWAY_TEAM_LINEUP]: {
		color: 'bg-white',
		border: 'border-gray-300/50',
		textColor: 'text-gray-700'
	},
	[MatchupStatusEnum.READY_TO_BE_STARTED_STATUS]: {
		color: 'bg-white',
		border: 'border-gray-300/50',
		textColor: 'text-gray-700'
	},
	[MatchupStatusEnum.BYE_MATCHUP_STATUS]: {
		color: 'bg-white',
		border: 'border-gray-300/50',
		textColor: 'text-gray-700'
	}
} satisfies Record<MatchupStatusEnum, { color: string; dot?: string; border: string; textColor: string }>;

const statusText: Record<MatchupStatusEnum, string> = {
	[MatchupStatusEnum.SCHEDULED_MATCHUP_STATUS]: 'Starting soon',
	[MatchupStatusEnum.SCHEDULED_WAITING_FOR_HOME_TEAM_LINEUP]: 'Starting soon',
	[MatchupStatusEnum.SCHEDULED_WAITING_FOR_AWAY_TEAM_LINEUP]: 'Starting soon',
	[MatchupStatusEnum.IN_PROGRESS_MATCHUP_STATUS]: 'Live',
	[MatchupStatusEnum.COMPLETED_MATCHUP_STATUS]: 'Final score',
	[MatchupStatusEnum.DELAYED_MATCHUP_STATUS]: 'Delayed',
	[MatchupStatusEnum.UNSCHEDULED_MATCHUP_STATUS]: 'Unscheduled',
	[MatchupStatusEnum.UNDEFINED_MATCHUP_STATUS]: 'Undefined',
	[MatchupStatusEnum.READY_TO_BE_STARTED_STATUS]: 'Ready to be played',
	[MatchupStatusEnum.BYE_MATCHUP_STATUS]: 'Starting soon'
};

interface MatchupStatusBadgeProps {
	type: MatchupStatusEnum;
	className?: string;
}

export const MatchupStatusBadge = ({ type, className = '' }: MatchupStatusBadgeProps) => {
	return (
		<div
			className={`
        inline-flex items-center gap-2 rounded-lg border
        px-3 py-1 text-xs
        font-medium text-gray-700
        ${statusConfig[type].color}
        ${statusConfig[type].border}
		${statusConfig[type].textColor}
        ${className}
      `}
		>
			{statusText[type]}
		</div>
	);
};
